//
// Partner carousel
//

$(function() {
    var partnerCarousel = $('.partners__carousel'),
        autoPlayTimeout = 5000;

    // Randomize silver entries
    partnerCarousel.each(function(){
        $(this).randomizeEntries('.randomize');
    });

    // Initialize carousel
    partnerCarousel.owlCarousel({
        loop: true,
        autoplay: true,
        slideBy: 2,
        nav: true,
        autoplayHoverPause: true,
        autoplayTimeout: autoPlayTimeout,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        freeDrag: false,
        navText: ['<span class="sr-only">Previous</span><i class="fal fa-chevron-left" aria-hidden="true"></i>', '<span class="sr-only">Next</span><i class="fal fa-chevron-right" aria-hidden="true"></i>'],
        responsive: {
            0: {
                items: 2,
            },
            768: {
                items: 4,
            },
            992: {
                items: 6,
            }
        }
    });
    
    // Initialize owl tabbing plugin
    partnerCarousel.owlTabbing();

    // Fix bug where navigation items disappear on load
    partnerCarousel
        .find('.owl-nav')
        .removeClass('disabled');

    // Fix bug where navigation items disappear on change and resize
    partnerCarousel.on('changed.owl.carousel resized.owl.carousel', function(event) {
        $(this)
            .find('.owl-nav')
            .removeClass('disabled');
    });
    
    // Pause button for partner carousel
    $('.partners').each(function() {
        var $this = $(this),
            associatedCarousel = $this.find('.partners__carousel'),
            playPauseButton = $this.find('.partners__play-pause');
            
        playPauseButton
            .insertAfter($this.find('.owl-next'));
            
        playPauseButton.on('click', function() {
            var $btn = $(this);
            
            $btn.toggleClass('paused');
            
            if ($btn.hasClass('paused')) {
                associatedCarousel.trigger('stop.owl.autoplay');
            } else {
                associatedCarousel.trigger('play.owl.autoplay',[autoPlayTimeout]);
            }
        });
    });
});